export const SIMULATION_STATUS_KEY = 'SIMULATION_STATUS_KEY';
